import { render } from "./AddStrategyModal.vue?vue&type=template&id=6b840f04&scoped=true"
import script from "./AddStrategyModal.vue?vue&type=script&lang=js"
export * from "./AddStrategyModal.vue?vue&type=script&lang=js"

import "./AddStrategyModal.vue?vue&type=style&index=0&id=6b840f04&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b840f04"]])

export default __exports__